export default __webpack_public_path__ + "static/media/HU.c67eaf01.svg";